import React from 'react';
import '../styles/PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <div className="main-container">
        <aside className="sidebar">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="#info-collect">Information We Collect</a></li>
            <li><a href="#how-collect">How We Collect</a></li>
            <li><a href="#how-use">How We Use</a></li>
            <li><a href="#how-share">How We Share</a></li>
            <li><a href="#cookies">Cookies</a></li>
            <li><a href="#rights">Your Rights</a></li>
            <li><a href="#security">Data Security</a></li>
            <li><a href="#transfers">International Transfers</a></li>
            <li><a href="#contact">Contact Us</a></li>
          </ul>
        </aside>

        <main className="content">
          <h2>Privacy Policy</h2>
          <p className="last-updated"><strong>Last Updated: March 24, 2025</strong></p>

          <div className="content-section">
            <p>Welcome to Dr. BhuPat Pharma Pvt Ltd, a pharmaceutical company established on February 19, 2024, in Chh. Sambhajinagar, Maharashtra, India. We are committed to advancing women's health through innovative gynecare solutions. This Privacy Policy outlines how we collect, use, disclose, and protect your personal information when you visit our website <a href="https://www.drbhupatpharma.com">website link</a> or engage with our services.</p>
          </div>

          <div className="content-section">
            <h3 id="info-collect">1. Information We Collect</h3>
            <p>We collect the following to support our mission:</p>
            <ul>
              <li><strong>Personal Information:</strong> Name, email, phone, address, or professional details (e.g., for healthcare providers) via forms or subscriptions like Drxperientia.</li>
              <li><strong>Health-Related Information:</strong> Data you provide (e.g., inquiries about BHUGEST 200SR), treated with strict confidentiality.</li>
              <li><strong>Usage Data:</strong> IP address, browser details, and Site interactions via cookies.</li>
              <li><strong>Professional Data:</strong> From healthcare partners in Maharashtra.</li>
            </ul>
          </div>

          <div className="content-section">
            <h3 id="how-collect">2. How We Collect Information</h3>
            <p>We collect data through:</p>
            <ul>
              <li>Direct submissions (e.g., forms, inquiries).</li>
              <li>Automated tools like cookies.</li>
              <li>Third parties, such as doctors, where permitted by law.</li>
            </ul>
          </div>

          <div className="content-section">
            <h3 id="how-use">3. How We Use Your Information</h3>
            <p>We use your data to:</p>
            <ul>
              <li>Provide services and product information (e.g., RAYPAT D3).</li>
              <li>Educate about women's health.</li>
              <li>Send marketing updates (with consent).</li>
              <li>Improve our Site.</li>
              <li>Comply with India's DPDP Act 2023.</li>
            </ul>
          </div>

          <div className="content-section">
            <h3 id="how-share">4. How We Share Your Information</h3>
            <p>We do not sell your data. We may share it with:</p>
            <ul>
              <li><strong>Service Providers:</strong> For IT or analytics, under confidentiality.</li>
              <li><strong>Healthcare Partners:</strong> For treatment, with consent.</li>
              <li><strong>Regulators:</strong> For legal compliance.</li>
              <li><strong>Business Transfers:</strong> With safeguards during mergers.</li>
            </ul>
          </div>

          <div className="content-section">
            <h3 id="cookies">5. Cookies and Tracking Technologies</h3>
            <p>We use cookies to enhance your experience. You can manage them via browser settings or our <a href="#">Cookie Policy</a>.</p>
          </div>

          <div className="content-section">
            <h3 id="rights">6. Your Rights and Choices</h3>
            <p>Under laws like DPDP Act 2023, you may:</p>
            <ul>
              <li>Access, correct, or delete your data.</li>
              <li>Opt out of marketing.</li>
              <li>Request data portability.</li>
            </ul>
            <p>Contact us below to exercise these rights.</p>
          </div>

          <div className="content-section">
            <h3 id="security">7. Data Security</h3>
            <p>We protect your data with:</p>
            <ul>
              <li>Encryption for sensitive information.</li>
              <li>Training for our 24-member team.</li>
              <li>Regular security reviews.</li>
            </ul>
            <p>No system is fully secure, but we prioritize your trust.</p>
          </div>

          <div className="content-section">
            <h3 id="transfers">8. International Data Transfers</h3>
            <p>As we grow, data may transfer internationally, compliant with DPDP Act 2023.</p>
          </div>

          <div className="content-section">
            <h3>9. Retention of Information</h3>
            <p>We retain data only as necessary, then securely dispose of it.</p>
          </div>

          <div className="content-section">
            <h3>10. Third-Party Links</h3>
            <p>Links to external sites (e.g., <a href="https://koye.co/">koye.co</a>) are not our responsibility—review their policies.</p>
          </div>

          <div className="content-section">
            <h3>11. Children's Privacy</h3>
            <p>Our Site is not intended for those under 18.</p>
          </div>

          <div className="content-section">
            <h3>12. Changes to This Privacy Policy</h3>
            <p>We'll notify you of updates via email or Site notices.</p>
          </div>

          <div className="content-section">
            <h3 id="contact">13. Contact Us</h3>
            <p>For questions or rights requests, contact:</p>
            <ul>
              <li>Email: <a href="mailto:Info@drbhupatpharma.com">Info@drbhupatpharma.com</a></li>
              <li>Phone:  8850-694241</li>
              <li>Address: BS-1, Ground floor, Manik Arcade, Chetana Nagar, Kalda Corner, Chhatrapati Sambhajinagar, Maharashtra 431005</li>
            </ul>
          </div>
        </main>
      </div>
    </div>
  );
};

export default PrivacyPolicy;